import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BlackboardComponent} from '@app/modules/blackboard/components/blackboard/blackboard.component';
import {FormsModule} from '@angular/forms';


@NgModule({
    declarations: [
        BlackboardComponent
    ],
    exports: [
        BlackboardComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class BlackboardModule { }
